// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9b0634cb","977":"f71b7a63"}[chunkId] + ".chunk.js";
};